export enum ECryptoMethodTypes {
  depositAddress = 'deposit_crypto_address',
  address = 'address',
  tag = 'tag',
}
